/* eslint-disable no-unused-vars */
import Store from '../store/index';

export default {
  initApplicationView() {
    const el = document.getElementsByClassName('desktop-view')[0];
    if (typeof el === 'undefined') return;
    el.classList.add('mobile-view');
    el.classList.remove('desktop-view');
  },
  /* eslint no-param-reassign: "warn" */
  initSections(element) {
    const sections = Array.from(element.querySelectorAll('section')).map((e) => e.id);
    element.style.width = `${sections.length * window.innerWidth}px`;
    element.style.marginTop = '1.5%';
    Store.commit('initSections', {
      sections,
      selectedView: 0,
      element,
    });
  },
  reinitSections(element) {
    const sections = Array.from(element.querySelectorAll('section')).map((e) => e.id);
    element.style.width = `${sections.length * window.innerWidth}px`;
    element.style.marginTop = '1.5%';

    const appSection = document.getElementsByClassName('application-section')[0];
    appSection.style.left = `-${Store.state.selectedView * window.innerWidth}px`;
  },
  goToNextView(direction) {
    // Prepare variables
    const appSection = document.getElementsByClassName('application-section')[0];
    let counter = 0;

    // Calculate animation length
    const width = window.innerWidth * (direction === 'left' ? -1 : 1);
    appSection.style.transform = `translateX(${width}px)`;

    // Add transition class style
    if (!appSection.classList.contains('transition')) { appSection.classList.add('transition'); }

    appSection.addEventListener('transitionend', () => {
      // Guard clause against multiple calls within one a single transition
      counter += 1;
      if (counter > 1) return;

      // Set position, adjust for any offset
      const position = appSection.getBoundingClientRect();
      if (!Store.state.sectionOffset) { Store.commit('saveSectionOffset', { offSet: position.left - width }); }
      const left = (Store.state.sectionOffset * -1) + position.left;
      appSection.style.left = `${left}px`;

      // Clean up
      appSection.classList.remove('transition');
      appSection.style.transform = '';
    });
    window.scrollTo(0, 20);
  },
  async swipeHandler(direction, comp) {
    if (!comp.$store.state.isMobile) return;

    const { selectedView } = Store.state;
    const current = Store.getters.currentSection;
    if (direction === 'top' || direction === 'bottom') return;

    if (direction === 'left' && await comp.HasErrorInSection(Store.getters.currentSection)) {
      comp.$nextTick(() => {
        // - 175 is offset because of Sticky positional DNN header.
        window.scrollTo(0, (document.querySelector('.error').getBoundingClientRect().top - 175) + window.pageYOffset);
      });
      return;
    }

    if (direction === 'left' && selectedView + 1 >= Store.state.sections.length) return;
    if (direction === 'right' && (selectedView - 1 < 0)) return;

    if (direction === 'left') {
      // eslint-disable-next-line no-plusplus
      Store.commit('changeSelectedView', { view: selectedView + 1 });
    } else {
      // eslint-disable-next-line no-plusplus
      Store.commit('changeSelectedView', { view: selectedView - 1 });
    }

    const next = Store.getters.currentSection;

    if (comp.SetIndexes) {
      comp.SetIndexes(current, next);
    }

    this.goToNextView(direction);
  },
};
